module.exports = {
  en: {
    'HRES7DE2': {
      '5': 'Record Date from',
      '7': 'To',
      '10': 'For Year',
      '20': 'Tr.Course',
      '30': 'Tr.Class no.',
      '40': 'Record date',
      '50': 'TR.Course code',
      '60': 'TR.Course Name',
      '70': 'Class no.',
      '80': 'Type of Training',
      '90': 'Status',
      '95': 'Record Date',
      '100': 'Pending for training results',
      '110': 'TR.results recorded'
    },
    'HRES7DE4': {
      '10': 'topics',
      '20': 'topic',
      '30': 'detail',
      '40': 'Attach file',
      '50': 'URL'
    },
    'HRES7DE5': {
      '10': 'Assessment no.',
      '20': 'Evaluation form',
      '30': 'Appraisor i.d',
      '40': 'Section no.',
      '50': 'detail',
      '60': 'score',
      '70': 'full',
      '80': 'Score',
      '90': 'Item',
      '100': 'detail',
      '110': 'Weight',
      '120': 'Grade',
      '130': 'Score',
      '140': 'Total',
      '150': 'Total'
    },
    'HRES7DE6': {
      '10': 'Instructor',
      '20': 'Course',
      '30': 'Subject',
      '40': 'No.Of Trainee',
      '50': 'Person',
      '60': 'No.Of Evaluation',
      '70': 'Person',
      '80': 'Evaluation Form',
      '90': 'Section',
      '100': 'Description',
      '110': 'Full Score',
      '120': 'Avg Score',
      '130': 'Total',
      '140': 'Grade',
      '150': 'Remark'
    },
    'HRES7DE7': {
      '10': 'Seq. No.',
      '20': 'Evaluation Form',
      '30': 'Evaluated By',
      '40': 'Section',
      '50': 'Description',
      '60': 'Score',
      '70': 'Full',
      '80': 'Item No.',
      '90': 'Description',
      '100': 'Definition',
      '110': 'Weight',
      '120': 'Grade',
      '130': 'Score',
      '140': 'Total',
      '150': 'Total'
    },
    'HRES7DEP1': {
      '10': 'for year',
      '20': 'Tr.Course',
      '30': 'Class no.',
      '40': 'Course Outline',
      '50': 'Type of tr.',
      '60': 'category',
      '70': 'Objective',
      '80': 'From training dte.',
      '90': 'Training hours',
      '100': 'Hour',
      '110': 'Expense',
      '120': 'baht',
      '130': 'Institution',
      '140': 'Place',
      '150': 'Instructor id.',
      '160': 'Auto Update Competency',
      '170': 'Yes',
      '180': 'No',
      '190': 'Certificate No.',
      '200': 'Certified date',
      '210': 'Type of development',
      '220': 'Training results',
      '230': 'Score before',
      '240': 'Scores after training',
      '250': 'Commitment Conditions',
      '260': 'Evaluation result',
      '270': 'pass',
      '280': 'failed',
      '290': 'last date of assessment'
    },
    'HRES7DEP2': {
      '10': 'Course Evaluation',
      '20': 'Evaluation form',
      '30': 'Section no.',
      '40': 'detail',
      '50': 'Full score',
      '60': 'Average',
      '70': 'Total',
      '80': 'Remarks'
    },
    'HRES7DEP3': {
      '1': 'Instructor Performance',
      '10': 'Instr. I.D',
      '20': 'Name',
      '30': 'Subject',
      '40': 'Subject Name',
      '50': 'Score',
      '60': 'No. of',
      '70': 'Appraisor',
      '80': 'Remark',
      '90': 'Training Date',
      '100': 'From',
      '110': 'To'
    },
    'HRES7DEP4': {
      '10': 'Other',
      '20': 'Knowledge from training.',
      '30': 'Benefits of Training',
      '40': 'Comments / suggestions'
    }
  },
  th: {
    'HRES7DE2': {
      '5': 'วันที่บันทึกตั้งแต่',
      '7': 'ตั้งแต่',
      '10': 'สำหรับปี',
      '20': 'หลักสูตร',
      '30': 'รุ่นที่',
      '40': 'วันที่บันทึก',
      '50': 'รหัสหลักสูตร',
      '60': 'ชื่อหลักสูตร',
      '70': 'รุ่น',
      '80': 'ประเภทการอบรม',
      '90': 'สถานะ',
      '95': 'วันที่บันทึก',
      '100': 'รอบันทึกผลการอบรม',
      '110': 'บันทึกสรุปผลแล้ว'
    },
    'HRES7DE4': {
      '10': 'หัวข้อที่',
      '20': 'หัวข้อเรื่อง',
      '30': 'รายละเอียด',
      '40': 'Attach file',
      '50': 'URL'
    },
    'HRES7DE5': {
      '10': 'ประเมินลำดับที่',
      '20': 'รหัสแบบฟอร์มประเมิน',
      '30': 'รหัสผุ้ประเมิน',
      '40': 'ส่วนที่',
      '50': 'รายละเอียด',
      '60': 'คะแนน',
      '70': 'เต็ม',
      '80': 'คะแนนที่ได้',
      '90': 'ข้อที่',
      '100': 'รายละเอียด',
      '110': 'Weight',
      '120': 'Grade',
      '130': 'คะแนนที่ได้',
      '140': 'รวม',
      '150': 'รวม'
    },
    'HRES7DE6': {
      '10': 'ชื่อวิทยากร',
      '20': 'หลักสูตร',
      '30': 'เรื่อง',
      '40': 'จำนวนคนเข้าอบรม',
      '50': 'คน',
      '60': 'จำนวนคนประเมิน',
      '70': 'คน',
      '80': 'แบบฟอร์มการประเมิน',
      '90': 'ส่วนที่',
      '100': 'รายละเอียด',
      '110': 'คะแนนเต็ม',
      '120': 'คะแนนเฉลี่ย',
      '130': 'รวม',
      '140': 'เกรดประเมินที่ได้',
      '150': 'หมายเหตุการประเมิน'
    },
    'HRES7DE7': {
      '10': 'ประเมินลำดับที่',
      '20': 'รหัสแบบฟอร์มประเมิน',
      '30': 'รหัสผู้ประเมิน',
      '40': 'ส่วนที่',
      '50': 'รายละเอียด',
      '60': 'คะแนน',
      '70': 'เต็ม',
      '80': 'ข้อที่',
      '90': 'รายละเอียด',
      '100': 'คำจำกัดความ',
      '110': 'Weight',
      '120': 'Grade',
      '130': 'คะแนนที่ได้',
      '140': 'รวม',
      '150': 'รวม'
    },
    'HRES7DEP1': {
      '10': 'สำหรับปี',
      '20': 'หลักสูตร',
      '30': 'รุ่นที่',
      '40': 'รายละเอียดการอบรม',
      '50': 'ประะเภทการอบรม',
      '60': 'หมวด',
      '70': 'วัตถุประสงค์',
      '80': 'วันที่อบรมตั้งแต่',
      '90': 'จำนวนชั่วโมงอบรม',
      '100': 'ชม.',
      '110': 'ค่าใช้จ่าย',
      '120': 'บาท',
      '130': 'สถาบัน',
      '140': 'สถานที่',
      '150': 'รหัสวิทยากร',
      '160': 'Auto Update Competency',
      '170': 'Yes',
      '180': 'No',
      '190': 'เลขที่รับรอง',
      '200': 'วันที่รับรอง',
      '210': 'ประเภทการพัฒนา',
      '220': 'ผลการฝึกอบรม',
      '230': 'คะแนนก่อนอบรม',
      '240': 'คะแนนหลังอบรม',
      '250': 'เงื่อนไขในการผูกมัด',
      '260': 'ผลการประเมิน',
      '270': 'ผ่าน',
      '280': 'ไม่ผ่าน',
      '290': 'วันที่สิ้นสุดการประเมิน'
    },
    'HRES7DEP2': {
      '10': 'ประเมินหลักสุตร',
      '20': 'แบบฟอร์มการประเมิน',
      '30': 'ส่วนที่',
      '40': 'รายละเอียด',
      '50': 'คะแนนเต็ม',
      '60': 'คะแนนเฉลี่ย',
      '70': 'รวม',
      '80': 'หมายเหตุการประเมิน'
    },
    'HRES7DEP3': {
      '1': 'ผลประเมินวิทยากร',
      '10': 'รหัสวิทยากร',
      '20': 'ชื่อ',
      '30': 'เรื่อง',
      '40': 'ชื่อวิชา',
      '50': 'คะแนนที่ได้',
      '60': 'จำนวน',
      '70': 'คนประเมิน',
      '80': 'หมายเหตุการประเมิน',
      '90': 'วันที่อบรม',
      '100': 'จาก',
      '110': 'ถึง'
    },
    'HRES7DEP4': {
      '10': 'ข้อมูลอื่นๆ',
      '20': 'สรุปข้อมูลที่ได้จากการอบรม',
      '30': 'ประโยชน์ที่ได้จากการอบรม',
      '40': 'ข้อคิดเห็น/ข้อเสนอแนะ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres7de.js